<template>
    <el-input
        type="textarea"
        name="nam"
        :value="value"
        @input="val => $emit('input', val)"
        :maxlength="maxlength"
        :show-word-limit="showWordLimit"
        class="ah-el-input-textarea large"
        autosize
        resize="none"
        @keydown.enter.native="onNamInputKeydown($event)"
        @change="val => $emit('change', val)"
    ></el-input>
</template>
<script>
export default {
    name: 'ah-flex-input',
    props: {
        value: {
            type: String,
            default: '',
        },
        maxlength: {
            type: Number,
            default: 50,
        },
        showWordLimit: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        // 摘要輸入（防止換行）
        onNamInputKeydown(event) {
            if (event.key === 'Enter' || event.code === 'Enter' || event.keyCode === 13) {
                // eslint-disable-next-line no-param-reassign
                event.returnValue = false;
                return false;
            }
            return true;
        },
    },
};

</script>
